<p class="p-3 authorize-color">{{'otherTexts.youAreNotAuthorizedToAccessThisPage' | translate}}</p>
